import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './css/index.css';
import DataStore from "./api/DataStore";

window.dataStore = new DataStore();

// Split location into `/` separated parts, then render `Application` with it
function handleNewHash() {
  var location = window.location.hash.replace(/^#\/?|\/$/g, '').split('/');
  var application = <App location={location} />;
  ReactDOM.render(application, document.getElementById('root'));
}


// Handle the initial route and browser navigation events
handleNewHash()
window.addEventListener('hashchange', handleNewHash, false);



// WEBPACK FOOTER //
// ./src/index.js